export default class utilfunc {
    
    static datetoStr(date){

        if(date != null)
        {
            let data = new Date(date);
            let string_date =  (data.getDate() > 9 ? '' : '0') + data.getDate() + "/" +((data.getMonth() + 1) > 9 ? '' : '0') + (data.getMonth() + 1) + "/" + data.getFullYear();
            return string_date;
        }
        return null;
    }


    static datetoHoursStr(date){
        if(date != null)
        {
            let data = new Date(date);
            let string_date =  (data.getHours() > 9 ? '' : '0') + data.getHours() + ":" +((data.getMinutes() + 1) > 9 ? '' : '0') + (data.getMinutes() ) ;
            return string_date;
        }
        return null;
    }
    static randomUser() {
        return "auto-" + Math.random().toString(36) + "-" + (new Date().getTime()/1000); 
    }
    static randomPassword() {
        return Math.random().toString(36); 
    }

    
}